/**
 * Default visibility checker with data-visible attribute
 * Check, if element will be visible
 * @param element
 * @param schema
 * @return {boolean}
 */
export default function visibilityChecker(element, schema) {
  if (!element.props) return true;

  const { rules = {} } = schema;
  const vProp = element.props['data-visible'];

  if (vProp) {
    if (!rules[vProp]) return false;
    if (rules[vProp] && rules[vProp].invisible) {
      return false;
    }
  }

  return true;
}
